import React from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { EyeFilled } from "@ant-design/icons"
import { firestore } from '../../../../config/firebase';
import { useEffect, useState } from 'react';
import { Button, Tooltip } from 'antd';
import { Link } from 'react-router-dom';

export default function Adminuser() {
  const [usersData, setusersData] = useState([]);

  useEffect(() => {
    const getusersFromFirestore = async () => {
      const q = query(collection(firestore, 'users'), where('status', '==', 'active'));
      const querySnapshot = await getDocs(q);
      const array = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        array.push(data);
      });
      setusersData(array);
    };

    getusersFromFirestore();
  }, []);
  return (
    <>
      <h1 className=' text-[#fffa8a] pt-24 font-bold text-[48px] text-center italic'>All users Table</h1>
      <div className="container max-w-[90%]  text-[#fffa8a] px-4 mx-auto sm:px-8" style={{ background: "transparent" }}>
        <div className="py-8">
          <div className="px-4 py-4 -mx-4 overflow-x-auto sm:-mx-8 sm:px-8">
            <div className="inline-block min-w-full overflow-hidden rounded-lg shadow">
              <table className="min-w-full leading-normal">
                <thead>
                  <tr>
                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      Name
                    </th>
                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      E-mail
                    </th>
                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      Phone No.
                    </th>
                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      Whatsapp
                    </th>

                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      Gender
                    </th>
                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      Country
                    </th>
                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {usersData.map((rowData, index) => (
                    <tr key={index}>
                      <td className="px-5 py-5 text-sm  border-b text-left border-[#fffa8a] text-[#fffa8a]">
                        <div className="flex items-center">
                          <div>
                            <p className=" whitespace-no-wrap">{rowData.fullName}</p>
                          </div>
                        </div>
                      </td>
                      <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                        <p className=" whitespace-no-wrap">{rowData.email}</p>
                      </td>
                      <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                        <p className=" whitespace-no-wrap">{rowData.phoneNumber}</p>
                      </td>
                      <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                        <p className=" whitespace-no-wrap">{rowData.whatsappNumber}</p>
                      </td>
                      <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                        {rowData.gender}
                      </td>
                      <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                        {rowData.country}
                      </td>

                      <td className="px-5 py-5 text-sm  text-center border-b border-[#fffa8a] text-[#fffa8a]">
                        <Link to={`/dashboard/alluser/${rowData.uid}`}>
                          <Tooltip title="View User Record"  ><Button type="primary" icon={<EyeFilled className='text-[#fffa8a]' />} /></Tooltip></Link>

                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
